import { render, staticRenderFns } from "./horizontalSide.vue?vue&type=template&id=6d3ada84&scoped=true&"
import script from "./horizontalSide.vue?vue&type=script&lang=js&"
export * from "./horizontalSide.vue?vue&type=script&lang=js&"
import style0 from "./horizontalSide.vue?vue&type=style&index=0&id=6d3ada84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3ada84",
  null
  
)

export default component.exports